import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationPage.css';
import { notification } from 'antd';
import axios from 'axios';
import config from '../config.json';

function RegistrationPage() {
  const [fullName, setFullName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Basic validation
    if (fullName.trim() === '' || phoneNo.trim() === '' || password.trim() === '' || confirmPassword.trim() === '') {
      notification.error({
        message: 'Error',
        description: 'Please fill all fields.',
      });
      return;
    }

    if (password !== confirmPassword) {
      notification.error({
        message: 'Error',
        description: 'Passwords do not match.',
      });
      return;
    }

    if (phoneNo.length < 8) {
      notification.error({
        message: 'Error',
        description: 'Please enter a valid phone number.',
      });
      return;
    }

    // Format phone
    let formattedPhone = phoneNo.replace(/\D/g, ''); // remove non-digits
    if (formattedPhone.startsWith('0')) {
      formattedPhone = '211' + formattedPhone.substring(1);
    } else {
      formattedPhone = '211' + formattedPhone;
    }

    try {
      const apiUrl = config.API_URL;
      const response = await axios.post(`${apiUrl}/auth/register`, {
        fullName: fullName.trim(),
        phoneNo: formattedPhone,
        password,
      });

      if (response.data.status === true) {
        notification.success({
          message: 'Success',
          description: 'Registration successful! Please login.',
        });
        navigate('/');
      } else {
        notification.error({
          message: 'Error',
          description: response.data.result,
        });
      }
    } catch (error) {
      let errorMessage = 'Failed to register. Please try again.';
      if (error.response && error.response.data && error.response.data.result) {
        errorMessage = error.response.data.result;
      }
      notification.error({
        message: 'Error',
        description: errorMessage,
      });
    }
  };

  return (
    <div className="registration-container">
      <h1>Register</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="fullName">Full Name:</label>
          <input
            type="text"
            id="fullName"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Enter your full name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNo">Phone Number:</label>
          <div className="phone-input">
            <span className="prefix">+211</span>
            <input
              type="tel"
              id="phoneNo"
              value={phoneNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 9); // only digits, max 9
                setPhoneNo(value);
              }}
              placeholder="912345678"
              maxLength="9"
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
          />
        </div>
        <button type="submit">Register</button>
      </form>
      <p>Already have an account? <a href="/">Login</a></p>
    </div>
  );
}

export default RegistrationPage;